import { toSnakeCase } from "../utilities/helpers";
var ZIndex;
(function (ZIndex) {
    ZIndex["ABOVE_OVERLAY"] = "aboveOverlay";
    ZIndex["ABOVE_SHEET_CONTAINER"] = "aboveSheetContainer";
    ZIndex["ABOVE_TOAST"] = "aboveToast";
    ZIndex["ABOVE_POPOVER"] = "abovePopover";
    ZIndex["ABOVE_TOOLTIP"] = "aboveTooltip";
})(ZIndex || (ZIndex = {}));
export const getZIndexAsCssValue = (zIndex) => (typeof zIndex === "number" && zIndex) ||
    (typeof zIndex === "string" &&
        `var(--bui_z_index_${toSnakeCase(zIndex)})`) ||
    undefined;
export default ZIndex;
